export const PROJECT_SIDEBAR = 'PROJECT_SIDEBAR';
export const PERSON_SIDEBAR = 'PERSON_SIDEBAR';
export const REQUEST_SIDEBAR = 'REQUEST_SIDEBAR';
export const APPROVAL_PERSON_SIDEBAR = 'APPROVAL_PERSON_SIDEBAR';
export const APPROVAL_PROJECT_SIDEBAR = 'APPROVAL_PROJECT_SIDEBAR';
export const PROJECT_MASS_SIDEBAR = 'PROJECT_MASS_SIDEBAR';
export const ACTION_VACANCY_SIDEBAR = 'ACTION_VACANCY_SIDEBAR';
export const APPLICATION_SIDEBAR = 'APPLICATION_SIDEBAR';
export const ACTION_SIDEBAR = 'ACTION_SIDEBAR';
export const APPROVAL_APPLICATION_SIDEBAR = 'APPROVAL_APPLICATION_SIDEBAR';
export const COURSE_SIDEBAR = 'COURSE_SIDEBAR';
export const SCENARIO_SIDEBAR = 'SCENARIO_SIDEBAR';
export const NEWS_SIDEBAR = 'NEWS_SIDEBAR';
export const METRO_REQUEST_SIDEBAR = 'METRO_REQUEST_SIDEBAR';
